export default [
  'bot-name',
  'bot-bg-color',
  'bot-text-color',
  'user-text-color',
  'user-text-color',
  'bar-bg-color',
];
